import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { renderStructuredContent } from '../../renderContext';
import { AskOurExpertsContent } from './AskOurExpertContent';
import { AskOurExpertsDesktop } from './AskOurExpertsDesktop';
import { AskOurExpertsMobile } from './AskOurExpertsMobile';
import type { CreditCardsAskOurExpertsProps } from './types';
export const CreditCardsAskOurExperts = t0 => {
  const $ = _c(14);
  const {
    props
  } = t0;
  const {
    children,
    question
  } = props;
  let t1;
  if ($[0] !== children) {
    t1 = children.map(_temp);
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderedContents = t1;
  if (children.length === 1) {
    let t2;
    if ($[2] !== question) {
      t2 = question && <Typography fontWeight="bold">{question}</Typography>;
      $[2] = question;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== renderedContents[0] || $[5] !== t2) {
      t3 = <Box>{t2}{renderedContents[0]}</Box>;
      $[4] = renderedContents[0];
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t2;
  if ($[7] !== children) {
    t2 = children.map(_temp2);
    $[7] = children;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const experts = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingBottom: 3
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== experts || $[11] !== question || $[12] !== renderedContents) {
    t4 = <Box sx={t3}><AskOurExpertsMobile question={question} experts={experts} renderedContents={renderedContents} /><AskOurExpertsDesktop question={question} experts={experts} renderedContents={renderedContents} /></Box>;
    $[10] = experts;
    $[11] = question;
    $[12] = renderedContents;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(child, index) {
  return <AskOurExpertsContent key={`expert-content-${index}`} name={child.props.name} title={child.props.title} avatarUrl={child.props.avatarUrl} expertUrl={child.props.expertUrl} renderedChildren={renderStructuredContent(child.props.children)} />;
}
function _temp2(c) {
  return {
    name: c.props.name,
    avatarUrl: c.props.avatarUrl
  };
}